export const CommentSubjectType = {
  line: 'line',
  file: 'file',
} as const;

export type CommentSubjectTypeValue = (typeof CommentSubjectType)[keyof typeof CommentSubjectType];

export const CommentSide = {
  old: 'old',
  new: 'new',
} as const;

export type CommentSideValue = (typeof CommentSide)[keyof typeof CommentSide];

export type OptimisticLineComment = {
  id: number;
  filename: string;
  lineNumber: number;
  side: CommentSideValue;
  content: string;
  user: {
    login: string;
    avatar_url: string;
    html_url: string;
  };
  created_at: string;
  commit_id: string;
  isPending: boolean;
  start_line?: number;
  start_side?: CommentSideValue;
  subject_type?: CommentSubjectTypeValue;
};

export type PendingLineComment = OptimisticLineComment & {
  owner: string;
  repo: string;
  pullNumber: number;
  in_reply_to_id?: never;
  parent_is_pending?: never;
};

export type PendingLineCommentReply = OptimisticLineComment & {
  owner: string;
  repo: string;
  pullNumber: number;
  in_reply_to_id: number;
  parent_is_pending: boolean;
};

export type PendingComments = PendingLineComment | PendingLineCommentReply;
